// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ComplianceGradientIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 40 40">
    <path
      fill="url(#compliance-gradient_svga)"
      d="M36.82 24.35a8.6 8.6 0 0 0-4.17-7.32v-3.88a3.6 3.6 0 0 0-.98-2.53l-6.32-6.24a3.6 3.6 0 0 0-2.52-1.05H10.38A3.57 3.57 0 0 0 6.82 6.9v26.2a3.57 3.57 0 0 0 3.56 3.57h18.69a3.57 3.57 0 0 0 3.58-3.57v-1.43a8.5 8.5 0 0 0 4.17-7.32M24.32 6.4l5.26 5.27h-3.86a1.4 1.4 0 0 1-1.4-1.4zm6.16 26.67a1.4 1.4 0 0 1-1.41 1.4H10.38a1.4 1.4 0 0 1-1.4-1.4V6.9a1.4 1.4 0 0 1 1.4-1.4h11.77v4.77a3.57 3.57 0 0 0 3.57 3.56h4.76v2.29a9 9 0 0 0-2.15-.32 8.5 8.5 0 0 0-6.21 2.73h-7.35a1.08 1.08 0 1 0 0 2.17h5.8a9 9 0 0 0-.69 2.17h-5.11a1.08 1.08 0 1 0 0 2.16h5q.07 1.11.45 2.17h-5.45a1.08 1.08 0 0 0 0 2.17h6.66a8.5 8.5 0 0 0 9.12 3.2zm-2.15-1.85a6.88 6.88 0 1 1 0-13.77 6.88 6.88 0 0 1 0 13.77"
    />
    <path
      fill="url(#compliance-gradient_svgb)"
      d="M32.6 21.07a1.1 1.1 0 0 0-1.53 0l-4.25 4.25-1.34-1.34a1.08 1.08 0 1 0-1.53 1.54l2.1 2.1a1.1 1.1 0 0 0 1.53 0l5-5a1.1 1.1 0 0 0 .02-1.55"
    />
    <defs>
      <linearGradient
        id="compliance-gradient_svga"
        x1={6.82}
        x2={40.6}
        y1={3.33}
        y2={32.24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="compliance-gradient_svgb"
        x1={23.63}
        x2={30.84}
        y1={20.76}
        y2={29.62}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "ComplianceGradient",
);
export default ComplianceGradientIcon;
